import { Component, inject, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { MCFormisForm, MCDialog, MCFormValidationService, MCResponse, MC_RESPONSE_STATUS_CODE, MCFormStateService } from "@maslul/common-services";
import { MCButtonComponent, MCDialogComponent, MCFieldFormComponent } from "@maslul/common-components";
import { DeclarationsService } from "../../../../../services/pages/declarations/declarations";
import { Subscription } from "rxjs";
import { FormlyFieldConfig, FormlyModule } from "@ngx-formly/core";
import { ReactiveFormsModule } from "@angular/forms";
import { DialogModule } from 'primeng/dialog';
import cloneDeep from "clone-deep";
import { DeclarationsStore } from "../../../../../services/store/declarations";
import { TranslateService } from "@ngx-translate/core";
import { SendDialogComponent } from "../../components/send-dialog/send-dialog";
import { GeneralSkeletonComponent } from "../../components/general-skeleton/general-skeleton";
import { PageBaseComponent } from "../../../../shared/page-base";
import { FocusOnTabDirective } from "../../../../../services/shared/directives/focus-on-tab";
import { GeneralStore } from "../../../../../services/store/general";
import { SendService } from "../../../../../services/general/send";
import { RequestApprovalTypeDetailsStore } from "../../../../../services/store/approval-type-details-store";
import { TABS } from "../../../../../enum/request/TABS";

@Component({
    selector: 'mi-declarations',
    imports: [
        MCFieldFormComponent,
        ReactiveFormsModule,
        FormlyModule,
        MCButtonComponent,
        DialogModule,
        GeneralSkeletonComponent,
        MCDialogComponent,
        SendDialogComponent,
        FocusOnTabDirective
    ],
    templateUrl: './declarations.html',
    styleUrl: './declarations.scss',
    encapsulation: ViewEncapsulation.None
})
export class DeclarationsComponent extends PageBaseComponent implements OnInit, OnDestroy {

    private formStateService = inject(MCFormStateService);
    private translateService = inject(TranslateService);
    private declarationsService = inject(DeclarationsService);
    private declarationsStore = inject(DeclarationsStore);
    private formValidationService = inject(MCFormValidationService);
    private requestApprovalTypeDetailsStore = inject(RequestApprovalTypeDetailsStore);
    private generalStore = inject(GeneralStore);
    private sendService = inject(SendService);

    formisForm: MCFormisForm = new MCFormisForm();
    subscription: Subscription = new Subscription();
    displaySuccessDialog: boolean = false;
    tabsText = toSignal(this.translateService.stream('tabs'));

    dialogProperties: MCDialog = new MCDialog();

    genericText = toSignal(this.translateService.stream('generic'));

    unionReqiestId: number = 0;
    isSuccessSend: boolean = false;
    isExistAtachmnets: boolean = true;
    isSentRequest: boolean = false;


    ngOnInit() {
        this.initIsExistAttachments();
        this.initDialog();
        this.initFormisForm();
        this.subscription.add(this.generalStore.getIsSent().subscribe(isSent => this.isSentRequest = isSent));

    }

    initIsExistAttachments() {
        this.isExistAtachmnets = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTabs.includes(TABS.ATTACHMENTS);
    }

    initDialog() {
        //todo  dialogProperties.breakpoints to enum
        this.dialogProperties.breakpoints = {
            '960px': '100vw', // ברוחב 960px ומטה, רוחב הדיאלוג יהיה 75vw
            '640px': '80vw' // ברוחב 640px ומטה, רוחב הדיאלוג יהיה 80
        };
        this.dialogProperties.id = 'mi-send-dialog-from-declarations';

    }

    initFormisForm() {
        this.formisForm.options.formState = this.formStateService.getFormState();
        //this.formisForm.form = new FormGroup({});
        this.formisForm.model = cloneDeep(this.declarationsStore.getSnapshot().formisFormModel);
        this.initFields();


    }
    initFields() {
        this.subscription.add(
            this.declarationsService.getFields(this.formisForm)
                .subscribe((formisFormFields: Array<FormlyFieldConfig> | undefined) => {
                    if (formisFormFields) {
                        this.formisForm.fields = formisFormFields;
                    }
                }))
            ;
    }


    back() {
        this.declarationsStore.setFormisFormModel(cloneDeep(this.formisForm.model));
        if (this.isExistAtachmnets) {
            this.navigate('attachments')
        } else {
            this.navigate('request-details');
        }
    }

    next() {
        this.send();
    }

    send() {

        const isValid = this.formisForm.form.valid;

        this.declarationsStore.setFormisFormModel(cloneDeep(this.formisForm.model));

        if (isValid || (!this.isNewRequest && this.requestId)) {
            this.sendService.send().subscribe({
                next: (res: MCResponse) => {
                    this.dialogProperties.visible = true

                    if (res && res.code === MC_RESPONSE_STATUS_CODE.SUCCESS) {
                        this.unionReqiestId = res.data
                        this.isSuccessSend = true;
                    }
                    else {
                        this.isSuccessSend = false;
                    }
                },
                error: () => {
                    this.isSuccessSend = false;
                    this.dialogProperties.visible = true

                }
            })

        }
        else {
            this.formisForm.form.markAllAsTouched();
            const invalidFields = this.formValidationService.getInvalidControlsFlatMap(this.formisForm.form);
            console.log('declarations details get invalid field', invalidFields);


        }
    }



    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}